import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";

export async function getIsPremier(isAuthenticated) {
  if (!isAuthenticated) {
    return false;
  }

  try {
    const { get } = await sdkInstanceProvider("subscriptions");
    const subscriptions = await get();

    return subscriptions.length > 0;
  } catch (error) {
    noticeError(error);
    return false;
  }
}
